import Controller from '../abstracts/Controller';
import 'scss-templates/t-storelocator.scss';

export default class StoreLocatorController extends Controller {
  static get COMPONENTS() {
    return [
      'StoreLocatorComponent',
      'NewsletterComponent',
      'PrintComponent'
    ];
  }
}
